import { IBooking } from '@/models/passenger';
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import {
  BookingResult,
  PassengerInput,
  PricingCondition,
  ReviewResult,
  Booking,
} from '@/models/pricing';
import {
  SearchFlightsResult,
  SearchCondition,
  AutoCompleteResult,
  SearchRule,
} from '../models/flight-search';

const authInterceptor = [
  function success(res: AxiosResponse): AxiosResponse {
    return res;
  },
  function error(err) {
    if (err.response.status === 401 || err.response.status === 409) {
      const dialog = document.getElementById('dlgGoToApp');
      // const loadingDiv = document.getElementById('loading');
      // loadingDiv.style.display = 'block';
      dialog.style.display = 'block';
      // alert('go to app');
      return Promise.reject(err);
    }
  },
];

class FlightService {
  private axios: AxiosInstance;
  private axiosNoLoading: AxiosInstance;
  constructor(flightUrl: string) {
    const axiosOpts: AxiosRequestConfig = {
      baseURL: `${flightUrl}`,
      withCredentials: true,
    };
    this.axios = axios.create(axiosOpts);
    this.axiosNoLoading = axios.create(axiosOpts);
    this.axios.interceptors.request.use(
      (config) => {
        const loadingDiv = document.getElementById('loading');
        loadingDiv.style.display = 'block';
        return config;
      },
      (error) => {
        // Do something with request error
        const loadingDiv = document.getElementById('loading');
        loadingDiv.style.display = 'none';
        return Promise.reject(error);
      },
    );

    // Add a response interceptor
    this.axiosNoLoading.interceptors.response.use(...authInterceptor);
    this.axios.interceptors.response.use(...authInterceptor);
    this.axios.interceptors.response.use(
      (response) => {
        const loadingDiv = document.getElementById('loading');
        // Do something with response data
        loadingDiv.style.display = 'none';
        return response;
      },
      (error) => {
        const loadingDiv = document.getElementById('loading');
        // Do something with response error
        loadingDiv.style.display = 'none';
        return Promise.reject(error);
      },
    );
  }

  public async searchFlights(
    searchCondition: SearchCondition,
  ): Promise<SearchFlightsResult> {
    const { data } = await this.axios.get('/v1/flights/search', {
      params: searchCondition,
    });
    return data;
  }

  public async getSearchCondition(): Promise<SearchCondition> {
    const { data } = await this.axiosNoLoading.get(
      '/v1/flights/search-condition',
      {
        headers: {
          'X-USER-ID': 1,
        },
      },
    );
    return data;
  }

  public async getSearchRule(): Promise<SearchRule> {
    const { data } = await this.axiosNoLoading.get('/v1/flights/search-rule', {
      headers: {
        'X-USER-ID': 1,
      },
    });
    return data;
  }

  public async getPricingCondition(): Promise<PricingCondition> {
    const { data } = await this.axios.get('/v1/flights/pricing-condition', {
      headers: {
        'X-USER-ID': 1,
      },
    });
    return data;
  }

  public async savePassengers(passengers: PassengerInput): Promise<void> {
    const response = await this.axios.post(
      '/v1/flights/passengers',
      passengers,
    );
    if (response && response.data) {
      alert('Save successfully');
    }
  }

  public async getReview(
    pricingCondition: PricingCondition,
  ): Promise<ReviewResult> {
    const { data } = await this.axios.get('/v1/flights/review', {
      params: pricingCondition,
    });
    return data;
  }

  public async getReviewResult(): Promise<ReviewResult> {
    const { data } = await this.axios.get('/v1/flights/review-result');
    return data;
  }

  public async searchAirports(keyword: string): Promise<AutoCompleteResult> {
    const { data } = await this.axiosNoLoading.get(
      '/v1/airports?keyword=' + keyword,
    );
    return data;
  }

  public async booking(): Promise<BookingResult> {
    const { data } = await this.axios.post('/v1/flights/booking');
    return data;
  }

  public async getBooking(): Promise<Booking> {
    const { data } = await this.axios.get('/v1/flights/booking');
    return data;
  }
}

export const flightService = new FlightService(
  process.env.VUE_APP_API_BASE_URL,
);
export default FlightService;
